import { TASK_STATUS } from '../task/task.interface';
import type { TaskStatus } from '../task/task.interface';

/**
 * Status -> metric group mapping for the `driver-task-kpis` KPI. Unlike `order-kpis`, these 3
 * groups do not partition every counted status — statuses before `driving_to_pickup` count only
 * toward `assigned` (see `TASK_KPI_ASSIGNED_ONLY_STATUSES`).
 */
export const TASK_KPI_STATUS_GROUPS = {
  completed: [TASK_STATUS.COMPLETED],
  failed: [TASK_STATUS.FAILED],
  inprogress: [
    TASK_STATUS.DRIVING_TO_PICKUP,
    TASK_STATUS.ARRIVED_AT_PICKUP,
    TASK_STATUS.WAITING_FOR_PICKUP,
    TASK_STATUS.PICKUP_COMPLETED,
    TASK_STATUS.IN_TRANSIT,
    TASK_STATUS.DRIVING_TO_DELIVERY,
    TASK_STATUS.ARRIVED_AT_DELIVERY,
  ],
} satisfies Record<'completed' | 'failed' | 'inprogress', readonly TaskStatus[]>;

/** Never counted toward any `driver-task-kpis` metric, including `assigned`. */
export const TASK_KPI_EXCLUDED_STATUSES: readonly TaskStatus[] = [TASK_STATUS.CANCELLED];

/**
 * Pre-dispatch statuses (before `driving_to_pickup`) that count only toward `assigned`, never
 * toward `inprogress`/`completed`/`failed`.
 */
const TASK_KPI_ASSIGNED_ONLY_STATUSES: readonly TaskStatus[] = [
  TASK_STATUS.NEW,
  TASK_STATUS.CARRIER_ASSIGNED,
  TASK_STATUS.CARRIER_ACCEPTED,
  TASK_STATUS.CARRIER_REJECTED,
  TASK_STATUS.DRIVER_ASSIGNED,
  TASK_STATUS.DRIVER_ACCEPTED,
];

/** Every `TASK_STATUS` value counted toward the `assigned` metric — the union of the 3 named groups plus the pre-dispatch-only statuses. */
export const TASK_KPI_COUNTED_STATUSES: readonly TaskStatus[] = [
  ...TASK_KPI_ASSIGNED_ONLY_STATUSES,
  ...TASK_KPI_STATUS_GROUPS.inprogress,
  ...TASK_KPI_STATUS_GROUPS.completed,
  ...TASK_KPI_STATUS_GROUPS.failed,
];
